// @flow

import unifizeUser from "../index";
import Round from "src/components/user/ImageLabel/Round";

export default unifizeUser(Round);
